var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page-view', {loaded: !_vm.loading}]},[_c('h1',{staticClass:"red-title"},[_vm._v("404")]),_c('div',{staticClass:"red"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"white-title"},[_vm._v("404")]),_c('p',{staticClass:"descripion"},[_vm._v("\n                "+_vm._s(_vm.$t('common.pagenotfound'))+"\n            ")]),_c('Cta',{staticClass:"link",attrs:{"type":'router-link',"to":_vm.$trl({
                    name: 'Home',
                    params: {
                        locale: _vm.$route.params.locale
                    }
                }),"colors":{
                    default: { color: '#636776', background: '#FFFFFF' },
                    hover:   { color: '#FFFFFF', background: '#114991' }
                }}},[_vm._v("\n                "+_vm._s(_vm.$t('cta.backtohome'))+"\n            ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }